import { Routes } from '@angular/router';
import { SCOPES } from 'src/app/app.constants';
import { ScopeGuard } from 'src/app/modules/auth/services/scope.guard';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: 'notices',
    loadComponent: async () => await import('./notices/notices.component').then((m) => m.NoticesComponent),
  },
  {
    path: 'schedule',
    loadComponent: async () =>
      await import('./schedule/schedule-dashboard.component').then((m) => m.ScheduleDashboardComponent),
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.bookings.read] },
  },
  {
    path: 'operations-scoreboard',
    loadComponent: async () =>
      await import('./operational-scoreboard/operational-scoreboard.component').then(
        (m) => m.OperationalScoreboardComponent
      ),
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.operations.read] },
  },
  { path: '', loadComponent: async () => await import('./dashboard.component').then((m) => m.DashboardComponent) },
];
